import { ConfirmDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('ConfirmDialog')
export class ConfirmDialogNodeSchemaProvider extends SchemaProvider<ConfirmDialogWorkflowNode> {}
